import { useQuery } from '@tanstack/react-query';

import { apiClient } from '@/lib/http/api-client';

interface HealthResponse {
  status: boolean;
  message: string;
  timestamp: string;
}

export type ApiHealthState = 'checking' | 'online' | 'offline';

/**
 * Comprueba la disponibilidad de EDSuite API.
 *
 * Se usa en el login para dar un diagnóstico inmediato al usuario: si el backend
 * no responde, lo vemos antes de que intente autenticarse.
 */
export function useApiHealth(): ApiHealthState {
  const { isPending, isError, data } = useQuery({
    queryKey: ['api', 'health'],
    queryFn: ({ signal }) => apiClient.get<HealthResponse>('/api/health', { auth: false, signal }),
    retry: false,
    refetchInterval: 60_000,
    staleTime: 30_000,
  });

  if (isPending) return 'checking';
  if (isError || !data?.status) return 'offline';

  return 'online';
}
